import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  // Token stored in sessionStorage (cleared when tab closes — smaller XSS window
  // than localStorage). Primary auth path is the httpOnly cookie set by
  // /api/auth/login; this Bearer header is the cross-origin fallback.
  const token = sessionStorage.getItem("fleet_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 402 = company not activated (Stripe not paid). This is a normal gated state,
// not an error the UI needs to explode over — the ActivationContext + Layout
// handle it. Convert 402 into a resolved response with empty payload so callers
// don't need to add `.catch()` on every fetch. In dev this also stops CRA's
// error overlay from flashing during the gated redirect window.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 402) {
      return Promise.resolve({
        data: Array.isArray(error?.config?.__default) ? [] : (error?.config?.__default ?? {}),
        status: 402,
        __gated: true,
      });
    }
    return Promise.reject(error);
  }
);

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
